/* istanbul ignore file */
import { gql } from '@apollo/client';

export const GET_ALL_ROLES_QUERY = gql`
  query GetAllRolesQuery {
    getAllRoles {
      ID
      name
      description
    }
  }
`;
